import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { UiMessageSnackService } from '../../../core/components/message-snack/service/message-snack.service';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// config
import { navigationConfig } from '../../config/navigation.config';

// Own feature

@Component({
   selector: 'app-topmenu-nav-search-cont',
   templateUrl: './topmenu-nav-search-cont.component.html'
})
export class TopmenuNavSearchContComponent implements OnInit {

   // Observable from store
   @select((s: IAppState) => s.menuState.showNavSearch) showNavSearch$;

   constructor(
      private _store: NgRedux<IAppState>
   ) { }

   ngOnInit() {

   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/compc/topmenu-nav-search-cont/topmenu-nav-search-cont.component.ts